{
  "language": {
    "label": "语言",
    "select": "选择语言"
  },
  "nav": {
    "howItWorks": "课程模式",
    "programmes": "课程项目",
    "pricing": "价格",
    "contact": "联系我们",
    "admin": "管理后台",
    "resources": "家长资源",
    "reviews": "家长评价",
    "signIn": "家长登录",
    "portal": "家长中心",
    "book": "预约免费测评",
    "terms": "条款与条件",
    "refund": "退款政策",
    "privacy": "隐私声明",
    "tagline": "为低龄学习者打造的高端在线英语课程"
  },
  "hero": {
    "title": "4–12 岁儿童在线英语课程，真正练出口语流利度",
    "rating": "CELTA 认证教师 · 英语与心理学专业毕业",
    "credential": "CELTA 认证教师",
    "subtitleBefore": "面向 4–12 岁儿童的在线直播英语课，每班最多 5 人，超过 80% 的时间在开口练习。学习进度对照我们的",
    "subtitleLink": "CEFR 对标课程体系",
    "ctaPrimary": "预约免费测评",
    "ctaSecondary": "查看报名价格",
    "liveLesson": "直播课 · A1 小班",
    "imageAlt": "三名儿童在 Smart Word Labs 在线英语直播课上开心地说笑交流"
  },
  "approach": {
    "heading": "小班授课，大幅提升口语自信。",
    "link": "逐步了解我们的教学方法"
  },
  "programmes": {
    "heading": "按年龄与级别划分的课程",
    "intro": "每位学员都从免费测评和书面学习计划开始。孩子会被安排到符合其年龄段与 CEFR 级别的小班，而 IELTS Mastery 则为各年龄段考生提供一对一私教。",
    "cefrLabel": "CEFR 级别",
    "cefr": "CEFR {{level}}",
    "lessonLength": "课时长度",
    "cohortSize": "班级规模",
    "speakingTime": " · 80%+ 开口时间",
    "explore": "了解{{title}}",
    "exploreAria": "查看面向{{band}}的{{title}}完整介绍",
    "bookAria": "为{{title}}（{{band}}）预约免费英语测评",
    "book": "预约免费测评",
    "compareAll": "详细比较全部课程",
    "items": {
      "early-phonics-explorers": {
        "band": "4–6 岁",
        "title": "自然拼读启蒙班",
        "summary": "面向 4–6 岁儿童的在线英语直播课：自然拼读、初级词汇与开口自信，5 人小班教学。",
        "duration": "每节 30 分钟",
        "cohort": "最多 5 名儿童",
        "spots": "每组最多 5 名孩子"
      },
      "literacy-builders": {
        "band": "7–9 岁",
        "title": "读写进阶班",
        "summary": "面向 7–9 岁儿童的小班英语课，涵盖阅读流利度、结构化写作与日常会话，对标 CEFR A1–A2。",
        "duration": "每节 45 分钟",
        "cohort": "最多 5 名儿童",
        "spots": "每组最多 5 名孩子"
      },
      "confident-communicators": {
        "band": "10–12 岁",
        "title": "自信表达班",
        "summary": "面向 10–12 岁儿童的 CEFR 英语课程，培养议论文写作、辩论与面试表达，为中学阶段做好准备。",
        "duration": "每节 45 分钟",
        "cohort": "最多 5 名儿童",
        "spots": "每组最多 5 名孩子"
      },
      "ielts-mastery": {
        "band": "不限年龄",
        "title": "雅思精讲一对一",
        "summary": "面向各年龄段考生的雅思 A 类或 G 类一对一私教，围绕目标分数与考试日期定制。",
        "duration": "每节 45 分钟",
        "cohort": "一对一",
        "spots": "私人一对一"
      }
    }
  },
  "pricing": {
    "heading": "简单透明的月度价格",
    "headingPage": "儿童在线英语课程价格",
    "intro": "每个孩子每月一笔费用，按月计费，可随时取消。测评课与学习计划始终免费。",
    "introTeaser": "每个孩子每月一笔费用，按月计费，可随时取消。所有套餐均包含免费测评与书面学习计划。",
    "mostPopular": "最受欢迎",
    "perMonth": "美元 / 月",
    "perLesson": "每节课 {{amount}} 美元",
    "subscribe": "立即订阅",
    "signInToSubscribe": "登录后订阅",
    "seeMore": "在价格页面查看各套餐包含的内容",
    "noteLessonLength": "课时长度按年龄划分：4–6 岁 30 分钟，7–12 岁 45 分钟。",
    "noteCohorts": "课程时间为多伦多时间（ET）上午 9、10、11 点及下午 2、3、4、5、6 点。具体时段将在免费测评时确认。",
    "noteSibling": "兄弟姐妹同时报名，每位额外的孩子可省 10%。价格以美元计。",
    "tiers": {
      "cohort_starter_monthly": {
        "name": "小班入门",
        "lessons": "每月 8 节课",
        "cadence": "每周 2 节课",
        "features": [
          "最多 5 名儿童的小班",
          "45 分钟直播课，每周 2 次",
          "每周作业并由老师点评",
          "每月 CEFR 进度报告",
          "与 Salma 老师直接沟通",
          "每月 2 次调课额度"
        ]
      },
      "cohort_intensive_monthly": {
        "name": "小班强化",
        "lessons": "每月 16 节课",
        "cadence": "每周 4 节课",
        "features": [
          "最多 5 名儿童的小班",
          "45 分钟直播课，每周 4 次",
          "每周作业并由老师点评",
          "每月 CEFR 进度报告",
          "与 Salma 老师直接沟通",
          "每月 4 次调课额度",
          "优先安排班级"
        ]
      },
      "private_1on1_monthly": {
        "name": "一对一私教",
        "lessons": "每月 16 节课",
        "cadence": "每周 4 节课",
        "features": [
          "一对一授课，无小班——完全定制课程",
          "45 分钟直播课，每周 4 次",
          "每周作业并由老师点评",
          "每月 CEFR 进度报告",
          "与 Salma 老师直接沟通",
          "灵活调课（每月不限次数）",
          "围绕孩子目标定制学习节奏"
        ]
      },
      "ielts_mastery_1on1_monthly": {
        "name": "雅思精讲一对一",
        "lessons": "每月 16 节课",
        "cadence": "每周 4 节课",
        "features": [
          "不限年龄，人人可报",
          "针对雅思 A 类或 G 类的专项备考",
          "一对一授课，无小班——定制目标分数策略",
          "45 分钟强化课，覆盖口语、阅读、写作与听力",
          "写作 Task 1 与 Task 2 精批并给出分数反馈",
          "一对一口语模考与考官式反馈",
          "阅读与听力专项训练，含错题分析与时间管理技巧",
          "与 Salma 老师直接沟通",
          "灵活调课（每月不限次数）",
          "围绕考试日期定制学习节奏"
        ]
      },
      "starter_pack_onetime": {
        "name": "入门课包",
        "lessons": "4 节私人一对一课程",
        "cadence": "每节 30 分钟",
        "features": []
      }
    },
    "oneTime": "美元（一次性）",
    "getStarterPack": "购买入门课包",
    "starterNote": "先试上 4 节课再决定。若您在 30 天内报名，全部 79 美元将抵扣首月学费。"
  }
}
